import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

import SectionEyebrow from './SectionEyebrow';
import { REDESIGN_COLORS, REDESIGN_FONTS } from '../../constants';

const useStyles = makeStyles(() => ({
    root: ({ align, maxWidth, marginBottom }) => ({
        maxWidth: `${maxWidth}px`,
        margin: align === 'center' ? `0 auto ${marginBottom}px` : `0 0 ${marginBottom}px`,
        textAlign: align,
    }),
    eyebrow: {
        marginBottom: '18px',
    },
    // Sizing lives here rather than in the MUI theme because the theme's heading
    // scale still belongs to the old design. It moves to the theme in the
    // typography step, once every consumer is on the new scale.
    title: ({ titleSize }) => ({
        margin: 0,
        fontSize: titleSize,
        lineHeight: 1.08,
        letterSpacing: '-0.035em',
        fontWeight: REDESIGN_FONTS.weightHeading,
        color: REDESIGN_COLORS.dark,
    }),
    lead: ({ align }) => ({
        maxWidth: '620px',
        margin: align === 'center' ? '16px auto 0' : '16px 0 0',
        color: REDESIGN_COLORS.body,
        fontSize: '1.06rem',
        lineHeight: 1.6,
    }),
}));

/**
 * Eyebrow + heading + optional lead paragraph. This trio opens nearly every
 * section of the redesign, which is why it is a component rather than markup
 * repeated per section.
 */
const SectionHeading = ({
    eyebrow,
    title,
    lead,
    component: Component = 'h2',
    align = 'center',
    maxWidth = 780,
    marginBottom = 38,
    titleSize = 'clamp(2rem, 4.2vw, 3.4rem)',
    className,
}) => {
    const classes = useStyles({ align, maxWidth, marginBottom, titleSize });

    return (
        <div className={[classes.root, className].filter(Boolean).join(' ')}>
            {eyebrow ? <SectionEyebrow className={classes.eyebrow}>{eyebrow}</SectionEyebrow> : null}
            <Component className={classes.title}>{title}</Component>
            {lead ? <p className={classes.lead}>{lead}</p> : null}
        </div>
    );
};

export default SectionHeading;
